var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1.83334C10.4142 1.83334 1.83331 10.4143 1.83331 21C1.83331 31.5858 10.4142 40.1667 21 40.1667C31.5857 40.1667 40.1666 31.5858 40.1666 21C40.1666 10.4143 31.5857 1.83334 21 1.83334Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18604 33.1632C6.18604 33.1632 10.4583 27.7083 21 27.7083C31.5416 27.7083 35.8158 33.1632 35.8158 33.1632M21 21C22.5249 21 23.9875 20.3942 25.0658 19.3159C26.1442 18.2375 26.75 16.775 26.75 15.25C26.75 13.725 26.1442 12.2625 25.0658 11.1841C23.9875 10.1058 22.5249 9.5 21 9.5C19.475 9.5 18.0124 10.1058 16.9341 11.1841C15.8558 12.2625 15.25 13.725 15.25 15.25C15.25 16.775 15.8558 18.2375 16.9341 19.3159C18.0124 20.3942 19.475 21 21 21V21Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.e475f6238ffc28df6088218edaf8f63d.svg";
export { ForwardRef as ReactComponent };